/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".wrapper[_ngcontent-%COMP%]{margin-bottom:20px}.label-text[_ngcontent-%COMP%]{text-transform:uppercase;font-weight:700;font-size:10px;height:15px;letter-spacing:.02em;margin-bottom:8px}input[_ngcontent-%COMP%]{background:#f8f9fc;border:1px solid #e9ebf4;box-sizing:border-box;border-radius:6px;font-size:14px;padding:10px;width:100%;color:#1a3349}input[_ngcontent-%COMP%]:focus{border:1px solid #366bf3}input[_ngcontent-%COMP%]::-webkit-input-placeholder{color:#9da2bd;opacity:.9}.input-error[_ngcontent-%COMP%]{position:relative}"];
export { styles as styles };
